<div class="font-light">
    <div class="flex">
        <div mat-dialog-title class="w-2/3 text-gray-800 pl-2">{{data.activity}}</div>
        <br>
        <div class="w-1/3 mx-6">
            <h3 class="text-lg text-red-700 italic">See also in:</h3>
            <button mat-button [matMenuTriggerFor]="menu" class="text-lg text-red-700 hover:underline">Cities</button>
            <mat-menu #menu="matMenu" yPosition="below" class="bg-transparent">
                <div *ngFor="let city of data.cities" class="mx-2">
                    <div class="flex flex-col justify-center items-center">
                        <button
                            class="border-2 border-red-500 h-1/2 w-32 text-sm rounded-full px-1 py-1 mx-2 mb-1 text-red-500 text-sm rounded-full hover:bg-red-500 hover:text-red-300 place-self-center"
                            (click)="onCity(city)">
                            <div class="texxt">
                                {{city}}
                            </div>
                        </button>
                    </div>
                </div>
            </mat-menu>
        </div>
    </div>
    <div mat-dialog-content>
        <br>
        <div *ngIf="this.allowed">
            <p class="text-lg text-red-700 italic">*Click below to edit</p>
            <div class="text-gray-800 pl-2" [innerHTML]="data.summary" [contentEditable]="edit"
                [innerText]="data.summary" (blur)="onChange($event.target.innerText)" (focus)="onFocus()">
                {{data.summary}}</div>
        </div>
        <div *ngIf="!this.allowed">
            <div class="text-gray-800">{{data.summary}}</div>
        </div>
        <br>
        <h3 class="text-lg text-red-700 italic">&#x25B6; Learning question that this activity belongs to:</h3>
        <br>
        <div mat-dialog-title class="w-2/3 text-gray-800 pl-2">{{data.lq}}</div>
        <br>
        <h3 class="text-lg text-red-700 italic">&#x25B6; Innovative actions that this activity belongs to:</h3>
        <br>
        <div mat-dialog-title *ngFor="let action of data.actions; index as j;" class="text-gray-800 pl-2 text-md">
            {{j+1}}. {{action}}
        </div>
    </div>
    <div *ngIf="this.edited">
        <button
            class="float-right px-2 py-1 mx-1 border border-transparent shadow-sm text-sm font-medium rounded-full text-white bg-evaluationto hover:bg-evaluationfr"
            (click)="onUpdate(this.data.id, this.data.summary)">
            Save changes
        </button>
    </div>
    <div *ngIf="allowed">
        <button
            class="float-right px-2 py-1 mx-1 border border-transparent shadow-sm text-sm font-medium rounded-full text-white bg-red-500 hover:bg-red-600"
            (click)="onDelete()">
            <i class="far fa-trash-alt"></i>
        </button>
    </div>
    <swal></swal>
</div>